module.exports = __webpack_public_path__ + "static/media/XXL_Block.45474c1f.jpg";